module.exports = __webpack_public_path__ + "static/media/colicoli7.e97c28ec.webp";